// Core
import React, { useState, useEffect } from "react"
import { isMobile } from "react-device-detect"
import { localiseString } from "../../utils/localiseString"

// Components
import ScrollSection from "../locomotiveScroll/scrollSection"
import PlayBtn from "./../playBtn"
import Video from "./../video"
import JsonText from "../_jsonText"

// Style
import styles from "./interview.module.scss"

const Interview = ({
  count,
  scrollEvent,
  contentful_id,
  menuTitle,
  subheading,
  heading,
  description,
  posterImage,
  vimeoVideoId,
  reverse = false,
  sequence = false,
}) => {
  const [playState, setPlayState] = useState(false),
    [playing, setPlaying] = useState(false)

  const data = {
    content: "",
  }

  const anchorOverride = menuTitle
    ? menuTitle.replace(/\s+/g, "-").toLowerCase()
    : null

  const play = () => {
    setPlaying(true)
    setPlayState(true)
  }

  useEffect(() => {
    setTimeout(() => {
      if (!isMobile && scrollEvent && !sequence) {
        window.scroll.on("call", (value, way, obj) => {
          if (value === "interview-" + contentful_id)
            scrollEvent(way, count, obj)
        })
      }
    }, 200)
  }, [])

  return (
    <ScrollSection>
      <div
        id={`ep-${anchorOverride ? anchorOverride : "interview"}`}
        className={`${styles.wrap} ${reverse ? styles.reversed : ""} ${
          sequence ? styles.sequence : ""
        } container`}
        data-scroll
        data-scroll-call={`interview-${contentful_id}`}
        data-scroll-offset="45%, 45%"
      >
        <div className={`cols flex`}>
          <div
            className={`${styles.contentCol} col m12 t5 d4 ${
              data.content !== "" ? "dl3" : ""
            }`}
          >
            <div className={styles.content} data-scroll data-scroll-speed=".5">
              <p className={`${styles.mono} mono`}>
                {subheading ? subheading : localiseString("In conversation with")}
              </p>
              {description ? (
                <React.Fragment>
                  <h6>{heading}</h6>
                  <JsonText {...description} />
                </React.Fragment>
              ) : (
                <h3>{heading}</h3>
              )}
            </div>
          </div>
          <div
            className={`${styles.videoCol} ${
              data.content !== "" ? styles.extraMargin : ""
            } ${playing ? styles.playing : ""} col m12 t7 d6`}
          >
            <div className={styles.videoWrap}>
              <img
                src={posterImage.fluid.src}
                className={`${styles.poster}`}
                width={888}
                height={500}
                alt={heading}
              />
              <PlayBtn event={play} />
              <Video vidID={vimeoVideoId} playState={playState} fill={false} />
            </div>
          </div>
        </div>
      </div>
    </ScrollSection>
  )
}

export default Interview
